import {Component, OnInit} from '@angular/core';
import {BlockStatementAbstractComponent} from '../block-statement-abstract.component';
import {TimeReward} from '../../types/time.reward.type';

@Component({
    selector: 'core-time-rewards',
    templateUrl: './block-time-rewards.component.html',
    standalone: false
})
export class BlockTimeRewardsComponent extends BlockStatementAbstractComponent implements OnInit {
    showSection!: boolean;
    timeRewards!: TimeReward[];

    override ngOnInit(): void {
        super.ngOnInit();
        this.timeRewards = this.trsService.getUserTimeRewards();
        this.showSection = this.trsService.isTimeRewardsShownForClient() && !this.trsService.isSingleTimeRewardForUser();
    }

}
